import { Timestamp } from 'firebase/firestore';
import { TenantFeature } from './tenant.model.js';

export enum UserRule {
  userManagement = 'USER_MANAGEMENT', //User can view and edit all users
  assetUploading = 'ASSET_UPLOADING', //User can upload new assets
  assetDownloading = 'ASSET_DOWNLOADING', //User can download assets from DAM
  assetEditing = 'ASSET_EDITING', //User can edit assets
  assetViewing = 'ASSET_VIEWING', //User can view assets
  assetViewBlocked = 'ASSET_VIEW_BLOCKED', //User can view blocked assets
  assetApproval = 'ASSET_APPROVAL', //User can approve assets in waiting room
  collectionAdmin = 'COLLECTION_ADMIN', //User can edit, view and remove all collections
  guideAdmin = 'GUIDE_ADMIN', // User can edit, view and remove all guides
  guideViewing = 'GUIDE_VIEWING', // User can view guides
  projectAdmin = 'PROJECT_ADMIN', // Gives user access to all projects
  projectManagement = 'PROJECT_MANAGEMENT', // User can edit and add new projects
  projectEditing = 'PROJECT_EDITING', // Allow model tagging, asset verifying
  projectUploading = 'PROJECT_UPLOADING', // User can upload new assets
  projectDownloading = 'PROJECT_DOWNLOADING', // User can download assets
  projectExport = 'PROJECT_EXPORT', // User can approve and download/export assets
  tagManagement = 'TAG_MANAGEMENT', //User can view and edit all tags
  apiKeyManagement = 'API_KEY_MANAGEMENT', // User can manage API keys
}

export const userRuleGroups = [
  {
    name: 'SETTINGS',
    rules: [UserRule.userManagement, UserRule.apiKeyManagement],
  },
  {
    name: 'DAM',
    requiredFeature: TenantFeature.dam,
    rules: [
      UserRule.assetViewing,
      UserRule.assetViewBlocked,
      UserRule.assetDownloading,
      UserRule.assetUploading,
      UserRule.assetEditing,
      UserRule.tagManagement,
      UserRule.assetApproval,
      UserRule.collectionAdmin,
    ],
  },
  {
    name: 'GUIDES',
    requiredFeature: TenantFeature.guides,
    rules: [UserRule.guideViewing, UserRule.guideAdmin],
  },
  {
    name: 'CONSENT_MANAGER',
    requiredFeature: TenantFeature.consentManager,
    rules: [
      UserRule.projectAdmin,
      UserRule.projectManagement,
      UserRule.projectEditing,
      UserRule.projectUploading,
      UserRule.projectDownloading,
      UserRule.projectExport,
    ],
  },
];

export interface UserRole {
  id: string;
  name: string;
  userIds: string[];
  rules: UserRule[];
  creationDate: Timestamp;
  modificationDate: Timestamp;
}
